module.exports = __webpack_public_path__ + "img/logo.f53f4b56.png";